/**
 * Centralised query key factory. Every cached query in the app derives its
 * key from here so cache invalidation remains predictable.
 *
 * Convention: keys nest from generic to specific. Invalidate parent levels
 * to bust everything below them.
 */
export const qk = {
  me: {
    all: ['me'] as const,
    fleets: () => ['me', 'fleets'] as const,
    profile: () => ['me', 'profile'] as const,
  },
  loads: {
    all: (fleetId: string) => ['loads', fleetId] as const,
    list: (fleetId: string, filters: Record<string, unknown>) =>
      ['loads', fleetId, 'list', filters] as const,
    detail: (fleetId: string, loadId: string) =>
      ['loads', fleetId, 'detail', loadId] as const,
    pods: (fleetId: string, loadId: string) =>
      ['loads', fleetId, 'pods', loadId] as const,
  },
};
